import '../../assets/scss/spinner.scss';
import icoPlus from '../../assets/icons/ico_plus.svg';
import icoMinus from '../../assets/icons/ico_minus.svg';

class Spinner {
    constructor(el, options) {
        // if (!(el && el.nodeType && el.nodeType === 1)) {
        //     throw `Sortable: \`el\` must be an HTMLElement, not ${ {}.toString.call(el) }`;
        // }

        this.el = el;
        let defaults = {
            val: 0,
            min: 0,
            max: 9
        };

        if(options !== undefined){
            this.options = options;
        }else{
            this.options = defaults;
        }

        const elem = document.createElement('div');
        elem.classList.add('spinner-container');
        elem.innerHTML = `
            <label></label>
            <div class="count-wrapper">
                <button class="btn btn-icon btn-minus"><img class="ico" src=${icoMinus}></button>
                <input class="spinner-input" name="value" type="number" value=${this.options.val} min=${this.options.min} max=${this.options.max}>
                <button class="btn btn-icon btn-plus"><img class="ico" src=${icoPlus}></button>
            </div>`;
        this.el.append(elem);
        let btnMinus = this.el.querySelector('.btn-minus');
        let btnPlus = this.el.querySelector('.btn-plus');
        let spinnerInput = this.el.querySelector('.spinner-input');

        btnMinus.addEventListener('click', () => {
            // console.log("val", spinnerInput.value);
            if(spinnerInput.value > this.options.min){
                spinnerInput.value--;
            }
        });
        btnPlus.addEventListener('click', () => {
            // console.log("val", spinnerInput.value);
            if(spinnerInput.value < this.options.max){
                spinnerInput.value++;
            }
        });
    }   
}

export default Spinner;